import * as React from 'react'
import { SVGProps } from 'react'

const SvgEditIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g clipPath='url(#editIcon_svg__a)'>
      <path
        d='M.781 12.746c-.5.5-.78 1.178-.781 1.885V16h1.369c.707 0 1.385-.281 1.885-.781l8.895-8.896-2.472-2.472L.78 12.746Z'
        fill='#fff'
      />
      <path
        d='M15.43.57a1.747 1.747 0 0 0-2.473 0l-2.338 2.338 2.473 2.473 2.338-2.337a1.749 1.749 0 0 0 0-2.474Z'
        fill='#598DF1'
      />
    </g>
    <defs>
      <clipPath id='editIcon_svg__a'>
        <path fill='#fff' d='M0 0h16v16H0z' />
      </clipPath>
    </defs>
  </svg>
)

export default SvgEditIcon
